// extracted by mini-css-extract-plugin
export default {"wrapper":"FNcog8JcQq7Z_Sr0LWsh","title":"nwCCBrFpFE5ehBFKtrC7","focused":"fDzdrtha6ZFXI9iB9Y3r","profilelist":"TiiKLkNgeEtOnKCljDMv","digitfocus":"eUMhwM30F5v21B9154Pr"};